import api from '@/services/api';
import { make } from 'vuex-pathify';

const state = {
  geoportals: [],
  generatingGeoportalMapsIds: [],
  offers: [],
};

const mutations = {
  ...make.mutations(state),
};

const actions = {
  async createOffer({ dispatch }, offer) {
    await api.post('v2/offers/projects', offer);
    await dispatch('getOffers');
  },
  async editOffer({ dispatch }, { id, payload }) {
    await api.put(`v2/offers/projects/${id}`, payload);
    await dispatch('getOffers');
  },
  async getOffers({ commit }) {
    const r = await api.get('v2/offers/projects');
    commit('SET_OFFERS', r.data.data?.projects || []);
  },
  async deleteOffer({ dispatch }, { id }) {
    await api.delete(`v2/offers/projects/${id}`);
    await dispatch('getOffers');
  },
  async createProject({ dispatch }, { offerId, payload }) {
    await api.post(`v2/offers/projects/${offerId}/layers`, payload);
    await dispatch('getOffers');
  },
  async deleteProject({ dispatch }, { id, offerId }) {
    await api.delete(`v2/offers/projects/${offerId}/layers/${id}`);
    await dispatch('getOffers');
  },

  async getGeoportals({ commit }) {
    const r = await api.get('v2/geoportal/projects');
    commit('SET_GEOPORTALS', r.data.data?.projects || []);
  },
  async createGeoportal({ dispatch }, payload) {
    await api.post('v2/geoportal/projects', payload);
    await dispatch('getGeoportals');
  },
  async editGeoportal({ dispatch }, { uuid, payload }) {
    await api.put(`v2/geoportal/projects/${uuid}`, payload);
    await dispatch('getGeoportals');
  },
  async deleteGeoportal({ dispatch }, uuid) {
    await api.delete(`v2/geoportal/projects/${uuid}`);
    await dispatch('getGeoportals');
  },
  async refreshGeoportal({ dispatch }, { projectId, uuid }) {
    await api.post(`v2/geoportal/projects/${projectId}/${uuid}/refresh`);
    await dispatch('getGeoportals');
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
